import { render, staticRenderFns } from "./FormBank.vue?vue&type=template&id=d2071aca&scoped=true&"
import script from "./FormBank.vue?vue&type=script&lang=js&"
export * from "./FormBank.vue?vue&type=script&lang=js&"
import style0 from "./FormBank.vue?vue&type=style&index=0&id=d2071aca&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d2071aca",
  null
  
)

export default component.exports